import React, { useEffect, useState } from "react"
import API from "../../api"
import Button from "../../components/button"

// redux
import { mapDispatchProps, mapStateToProps } from "../../store/store"
import { connect } from "react-redux"
import { useQueryParams } from "../../hooks/useQueryParams"
import { useNavigate } from "react-router-dom"
import { useLanguage } from "@languages/index"

const ModelIntro = (props: any) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.models }
  const navigate = useNavigate()
  const params = useQueryParams()

  const renderImages = () => {
    return (
      <div className="flex flex-col justify-center">
        <div className="flex flex-row">
          <div className="flex flex-1 flex-col justify-center">
            <div className="flex flex-col mb-6 self-center">
              <span className="prose text-4xl font-bold text-black">{languageTexts.intro_text_1}</span>
              <span className="prose text-4xl font-bold text-black">{languageTexts.intro_text_2}</span>
            </div>
            <div className="flex flex-col self-center">
              <span className="prose text-base">{languageTexts.intro_text_3}</span>
              <span className="prose text-base mb-6">{languageTexts._intro_text_4(props.settings.currencyText)}</span>

              <Button
                text={languageTexts.intro_text_5}
                className={"rounded-full px-14 py-3"}
                buttonColor={"#FFBC64"}
                borderColor={"#FFBC64"}
                textColor={"WHITE"}
                textClassName={"prose prose-xl"}
                bordered
                onClick={() => {
                  navigate("/models")
                }}
              />
            </div>
          </div>
          <div className="flex flex-1">
            <img className="w-full px-32" src="/assets/images/select-model/models-landing-right.png" />
          </div>
        </div>

        <div className="w-full">
          <img className="w-full" src="/assets/images/select-model/select-model-guide-02.png" />
        </div>
        <div className="">
          <img className="w-full px-32 my-10" src="/assets/images/select-model/select-model-guide-03.png" />
        </div>
      </div>
    )
  }

  return (
    <>
      <div className="flex flex-col">{renderImages()}</div>
    </>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(ModelIntro)
